import React from 'react';
import Footer from '../../components/elements/Footer';
import Header from '../../components/elements/Header';
import { IBasicLayoutProps } from '../config';

import { MainContainer, MainContentWrapper } from './styles';

function MainLayout({ children }: IBasicLayoutProps) {
  return (
    <MainContainer>
      <Header />
      <MainContentWrapper id='main'>{children}</MainContentWrapper>
      <Footer />
    </MainContainer>
  );
}

export default MainLayout;
